import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_69: FaireProductEntity = {
  token: "catalog_prod_prod-69",
  type: "product",
  name: "River Stone Mortar And Pedestal - Style 3",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=400&fit=crop",
  priceDollars: 34.75,
  msrpDollars: 86.88,
  sku: "JA0069",
  caseSize: 2,
  material: "Metal",
  collectionToken: "col_japandi",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 203,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_games-puzzles"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
